import { api } from '../../plugins/api';

const getDefaultState = () => {
	return {
		autorisations: []
	}
}

const getEmpty = () => {
	return {
		autorisation: null,
		categorieAutorisation: null,
		dateDeFin: null,
		demandeAdmission: null,
		demandeInscription: null,
		id: null,
		numeroDePermisImport: null,
		pp: null,
		raisonRadiation: null,
		statut: null,
	}
}

const state = getDefaultState()

const getters = {
	GET_AUTORISATIONSDEPRATIQUE: (state) => { return state.autorisations.sort((a, b) => ('' + b.demandeAdmission).localeCompare(a.demandeAdmission)) },
}

const mutations = {
	SET_AUTORISATIONSDEPRATIQUE (state, autorisations) {
		state.autorisations = autorisations ? autorisations : []
	},
	SET_AUTORISATIONSDEPRATIQUE_ID (state, payload) {
    payload.element.id = payload.id
	},
	ADD_AUTORISATIONDEPRATIQUE (state, autorisation) {
		state.autorisations.push(autorisation)
	},
	REMOVE_AUTORISATIONDEPRATIQUE (state, autorisation) {
		state.autorisations.splice(state.autorisations.indexOf(autorisation), 1)
	},
	UPDATE_AUTORISATIONDEPRATIQUE(state, autorisation) {
		state.autorisations.splice(state.autorisations.indexOf(state.autorisations.find(a => a.id == autorisation.id)), 1);
		state.autorisations.push(autorisation);
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async getAutorisationDePratiqueByContactId ({ commit }, contactId) {
		const response = await api.get(`autorisationsdepratiques/contacts/` + contactId);
		commit("SET_AUTORISATIONSDEPRATIQUE", response.data ? response.data : [])
	},
	async getAutorisationDePratiqueByDemandeAdmissionId ({ commit }, demandeAdmissionId) {
		const response = await api.get(`autorisationsdepratiques/demandesadmissions/` + demandeAdmissionId);
		commit("SET_AUTORISATIONSDEPRATIQUE", response.data ? response.data : [])
	},
	async getAutorisationDePratiqueByDemandeInscriptionId ({ commit }, demandeInscriptionId) {
		const response = await api.get(`autorisationsdepratiques/demandesinscriptions/` + demandeInscriptionId);
		commit("SET_AUTORISATIONSDEPRATIQUE", response.data ? response.data : [])
	},
	async updateAutorisationDePratique ({ commit }, autorisation) {
		const response = await api.put(`autorisationsdepratiques`, autorisation);
		commit("UPDATE_AUTORISATIONDEPRATIQUE", response.data)
	},
	async createAutorisationDePratique ({ commit }, autorisation) {
		const response = await api.post(`autorisationsdepratiques`, autorisation);
		if (response.data) {
			commit("SET_AUTORISATIONSDEPRATIQUE_ID", { element: autorisation, id: response.data });
		}
	},
	async deleteAutorisationDePratique ({ state, commit }, id) {
		const response = await api.delete(`autorisationsdepratiques/` + id);
		if (response.data === true) {
			commit("REMOVE_AUTORISATIONDEPRATIQUE", state.autorisations.find(a => a.id === id))
		}
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})